import React from 'react';
import { cx } from '../../utils/cx.js';
import InfoTip from './InfoTip';

const formatValue = (value) => {
  if (typeof value === 'number' && Number.isFinite(value)) return value.toLocaleString('fr-FR');
  if (value === null || value === undefined || (typeof value === 'number' && Number.isNaN(value))) return '—';
  return value;
};

/**
 * Dense KPI tile (Insights GPSKpiTile): icon + label, big value, optional hint.
 * `fill` renders the colored synthesis variant: { gradient, valueColor, labelColor }.
 */
const StatTile = ({ label, value, icon: Icon = null, description = null, hint = null, fill = null, className = '' }) => {
  if (fill) {
    return (
      <div className={cx('relative h-full rounded-xl p-3 text-left', className)} style={{ background: fill.gradient }}>
        <div className="flex items-center gap-1.5" style={{ color: fill.labelColor }}>
          {Icon && <Icon className="h-4 w-4 flex-shrink-0" aria-hidden />}
          <span className="truncate text-[13px] font-semibold">{label}</span>
        </div>
        <div className="mt-1.5 text-2xl font-extrabold leading-none tracking-tight tabular-nums" style={{ color: fill.valueColor }}>
          {formatValue(value)}
        </div>
        {hint && <div className="mt-1.5 text-[11px] leading-snug" style={{ color: fill.labelColor }}>{hint}</div>}
      </div>
    );
  }

  return (
    <div className={cx('relative h-full rounded-xl border border-gray-200 bg-white p-3 text-left dark:border-gray-900 dark:bg-night-800', className)}>
      <div className="flex items-center gap-1.5 text-gray-600 dark:text-gray-400">
        {Icon && <Icon className="h-4 w-4 flex-shrink-0 text-gray-400 dark:text-gray-500" aria-hidden />}
        <span className="truncate text-[13px] font-semibold">{label}</span>
        {description && <InfoTip text={description} className="ml-auto flex-shrink-0" />}
      </div>
      <div className="mt-1.5 text-2xl font-extrabold leading-none tracking-tight tabular-nums text-gray-900 dark:text-gray-50">
        {formatValue(value)}
      </div>
      {hint && <div className="mt-1.5 text-[11px] text-gray-500 dark:text-gray-400">{hint}</div>}
    </div>
  );
};

export default StatTile;
